import React from 'react';
import styles from './Canvasses.module.css';

const CompanyList = ({ companies, onSelect, selectedCompanyId }) => {
  if (!companies || companies.length === 0) {
    return (
      <div className={styles.emptyState}>
        <p>No companies found</p>
      </div>
    );
  }

  return (
    <div className={styles.companyList}>
      {companies.map(company => (
        <div 
          key={company.id} 
          className={`${styles.companyItem} ${selectedCompanyId === company.id ? styles.selectedItem : ''}`}
          onClick={() => onSelect(company)}
        >
          <div className={styles.companyName}>
            <strong>{company.name}</strong>
            {company.url && (
              <a href={company.url} target="_blank" rel="noopener noreferrer" className={styles.companyUrl}>
                {company.url}
              </a>
            )}
            <span className={styles.companyIndustry}>
              {company.industry || 'Not specified'}
            </span>
            <span className={`${styles.visibilityBadge} ${company.isPublic ? styles.publicVisibility : styles.privateVisibility}`}>
              {company.isPublic ? 'Public' : 'Private'}
            </span>
            {company.objective && (
              <span className={styles.companyObjective}>
                {company.objective}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CompanyList;
